import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxBulkCreateRegistrationsV2Params,
  IIndirectTaxBulkCreateRegistrationsV2Response,
} from './types';

export async function createIndirectTaxRegistrationsBulk(
  body: IIndirectTaxBulkCreateRegistrationsV2Params
): Promise<{
  success: boolean;
  data?: IIndirectTaxBulkCreateRegistrationsV2Response;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/registrations-v2/bulk',
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to create registrations',
      };
    }

    const data: IIndirectTaxBulkCreateRegistrationsV2Response =
      await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create registrations';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
